__turbopack_context__.v({
  "gradient": "cut3YG_gradient",
  "ori-drift": "cut3YG_ori-drift",
  "ori-orbit": "cut3YG_ori-orbit",
  "ori-pulse": "cut3YG_ori-pulse",
});
